import React from 'react'
import Link from 'next/link'
import Image from 'next/image'
import { signatureTools } from '../../constants/signature'

const PdfToolsLinks = () => {
    return (
        <div className="w-full flex flex-col justify-center items-center">
            <h1 className="text-center text-2xl md:text-4xl text-gray-800 mb-10">
                Other PDF tools offered by BoloForms
            </h1>
            <div className="max-w-[1280px] mx-auto flex justify-center items-center flex-wrap gap-4">
                {
                    signatureTools.map((tool, index) => (
                        <Link href={tool.url} key={index} className="w-[220px] h-[80px] bg-white border rounded-xl drop-shadow-md px-4 hover:shadow-xl transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-105 z-0">
                            <div className="w-full h-full grid place-items-center text-xl text-gray-600">
                                {tool.title}
                            </div>
                        </Link>
                    ))
                }
            </div>
        </div>
    )
}

export default PdfToolsLinks
